import Constants from "expo-constants";

export const getBackendURL = () =>
  Constants.expoConfig?.extra?.backendAPIBaseURL;

export const getBackendURLDedicated = () =>
  Constants.expoConfig?.extra?.backendAPIBaseURLDedicated;
